import * as React from 'react';
import {   Drawer, } from 'antd';  


export interface IMoreInfoDrawerProps {
    visible: boolean;
    primaryColor: string;
    secondaryColor: string;
    onCancel: () => void; 
    infoType: number;
}


export interface IMoreInfoDrawerState {
  
}


export class MoreInfoDrawer extends React.Component<IMoreInfoDrawerProps, IMoreInfoDrawerState> {

    state = {

    };

    

    render() {
        const { visible, onCancel } = this.props;

        return (
            <Drawer closeIcon={null} className="font-face-gm" height="75" placement="top" 
            style={{ textAlign: 'center' }} onClose={onCancel} open={visible} >
              
            </Drawer>
        );
    }
}

export default MoreInfoDrawer;
